import {useDispatch} from 'react-redux';

import useConfigExternalLink from '@/hooks/externalLink/useConfigExternalLink';
import deviceStateService from '@/services/device/deviceStateService';
import mwStateService from '@/services/mw/mwStateService';
import productService from '@/services/product/productService';
import appRouterService from '@/services/route/appRouterService';
import {showDeviceRegistrationErrorModalAction, showHolderRegistrationModalAction} from '@/state/slices/modalSlice';

export const useRegistrationErrorButtons = ({errorContent, onClose, isHolder, isHolderReconnect}) => {
    const dispatch = useDispatch();
    const {primaryButton: primaryButtonConfig, cancelButton: secondaryButtonConfig} = errorContent;
    const {text, alt, externalLink} = primaryButtonConfig || {};
    const {redirectToExternalLink} = useConfigExternalLink(externalLink);

    const handlePrimaryButtonClick = () => {
        if (externalLink) {
            redirectToExternalLink();
            return;
        }

        productService.registerConsumerProduct({
            isHolder,
            onError: (iccError) => {
                dispatch(showDeviceRegistrationErrorModalAction({...iccError, isHolder, isHolderReconnect}));
            },
            onSuccess: () => {
                // redirection is handled in useRegistration
                onClose();
            },
            onNotRegisteredHolder: () => {
                dispatch(showHolderRegistrationModalAction());
            },
        });
        onClose();
    };

    const handleSecondaryButtonClick = () => {
        if (isHolderReconnect) {
            //if user close registration popup on holder reconnect then clear holder state
            mwStateService.clearHolderState();
        } else {
            deviceStateService.clearDeviceState();
            appRouterService.forwardToDevicesPage(true);
        }
        onClose();
    };

    const primaryButton = text
        ? {
              ariaLabel: alt,
              onClick: handlePrimaryButtonClick,
              text,
          }
        : undefined;

    const secondaryButton = secondaryButtonConfig
        ? {
              ariaLabel: secondaryButtonConfig.alt,
              onClick: handleSecondaryButtonClick,
              text: secondaryButtonConfig.text,
          }
        : undefined;

    return {
        primaryButton,
        secondaryButton,
    };
};
